import { useState } from "react";

export function CancelButton({ onConfirm, testid = "cancel-btn" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" data-testid={testid} onClick={() => setOpen(true)}
        className="block w-full text-center text-sm text-[#475569] underline">
        Cancelar
      </button>
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="cancel-dialog">
          <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)} />
          <div className="relative bg-white rounded-2xl p-5 max-w-sm w-full space-y-3">
            <h3 className="font-heading text-lg font-bold text-[#0F172A]">¿Cancelar reporte?</h3>
            <p className="text-sm text-[#475569]">Si cancelas, se perderá la información que no hayas guardado.</p>
            <div className="flex gap-3 pt-2">
              <button onClick={() => setOpen(false)} data-testid="cancel-keep-btn"
                className="flex-1 h-12 rounded-xl bg-[#F1F5F9] text-[#0F172A] font-semibold">Seguir editando</button>
              <button onClick={onConfirm} data-testid="cancel-confirm-btn"
                className="flex-1 h-12 rounded-xl bg-[#991B1B] text-white font-semibold">Cancelar reporte</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
